import { createAction, props } from '@ngrx/store';
import {PermissionsTarget} from "./permissions.facade";

export const getTargetPermissions = createAction(
  '[Roles] Get Target Permissions',
  props<{ payload: PermissionsTarget }>()
);

export const getTargetPermissionsSuccess = createAction(
  '[Roles] Get Target Permissions Success',
  props<{ payload: string[], target: PermissionsTarget }>()
);

export const getTargetPermissionsFailure = createAction(
  '[Roles] Get Target Permissions Failure',
  props<{ error: any }>()
);
